import { useState } from 'react'

import { useToast } from '@percent/lemonade'

export type TemplateLike = {
  id: string
}

type UseManageTemplateDefaultProps = {
  action: (templateId: string) => Promise<unknown>
  onSuccess: VoidFunction
  errorToastMessage: string
}

export const useManageTemplateDefault = <T extends TemplateLike>({
  action,
  onSuccess,
  errorToastMessage
}: UseManageTemplateDefaultProps) => {
  const { addToast } = useToast()
  const [target, setTarget] = useState<T | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [success, setSuccess] = useState(false)

  const handleAction = async () => {
    if (!target) {
      return
    }

    setIsLoading(true)

    try {
      await action(target.id)
      setTarget(null)
      setSuccess(true)
      onSuccess()
    } catch {
      addToast(errorToastMessage, 'error')
    } finally {
      setIsLoading(false)
    }
  }

  return {
    target,
    setTarget,
    isLoading,
    handleAction,
    success,
    closeSuccess: () => setSuccess(false)
  }
}
